import { styled } from '@mui/material/styles';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

export const IconSelect = styled(Select)(({ theme }) => ({
  height: '48px',
  display: 'flex',
  borderRadius: '8px',
  backgroundColor: theme.custom?.background2 || '#F5F5F5',
  color: theme.custom?.text,
  '&:hover': {
    cursor: 'pointer',
  },
  '& fieldset': {
    borderRadius: '18px',
    border: '0',
  },
  '& .MuiSelect-select': {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  '& .MuiSvgIcon-root': {
    color: theme.custom?.text,
  },
}));
export const IconMenuItem = styled(MenuItem)(({ theme }) => ({
  width: '100%',
  height: '48px',
  padding: '12px 16px',
  margin: 0,
  gap: '8px',
  backgroundColor: theme.custom?.background1 || 'white',
  borderBottom: `1px solid ${theme.custom?.stroke || '#D0D2D8'}`,
  display: 'flex',
  color: theme.custom?.text || 'black',
  alignItems: 'center',
  borderRadius: 0,
  '&.Mui-selected': {
    backgroundColor: theme.custom?.primaryLight || '#FAC8B2',
    opacity: 1,
    '&:hover': {
      backgroundColor: theme.custom?.primaryLight || '#FAC8B2',
    },
  },
  '&.Mui-disabled': {
    backgroundColor: theme.custom?.background3 || '#F5F5F5',
    opacity: 1,
    '&:hover': {
      backgroundColor: theme.custom?.background3 || '#F5F5F5',
    },
  },
  '&:hover': {
    backgroundColor: theme.custom?.primaryLight || '#FAC8B2',
    cursor: 'pointer',
  },
  '&:first-of-type': {
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
  },
  '&:last-of-type': {
    borderBottomLeftRadius: '8px',
    borderBottomRightRadius: '8px',
  },
}));
